import { render, staticRenderFns } from "./AdminNotificationBatchDetail.vue?vue&type=template&id=fa6bf598&scoped=true"
import script from "./AdminNotificationBatchDetail.vue?vue&type=script&lang=js"
export * from "./AdminNotificationBatchDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminNotificationBatchDetail.vue?vue&type=style&index=0&id=fa6bf598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6bf598",
  null
  
)

export default component.exports